function getQuantityLabelCount({count, any, more}) {
    return (
        count === 0 && any
            ? `${any}`
            : `${count || 0}${more || ''}`
    );
}

function getQuantityLabelTerm({count, more, singular, plural}) {
    return (
        count === 1 && !more
            ? `${singular}`
            : `${plural}`
    );
}

function getQuantityLabel({label, count, any, more, singular, plural}) {
    if (label) {
        return label;
    }

    const labelCount = getQuantityLabelCount({count, any, more});
    const labelTerm = getQuantityLabelTerm({count, more, singular, plural});

    return `${labelCount} ${labelTerm}`;
}

function toString(value) {
    return String(value);
}

export {
    getQuantityLabelCount,
    getQuantityLabelTerm,
    getQuantityLabel,
    toString
};
